import { ChartBuilderProvider as ChartBuilderProviderPackage } from '@chipinside/chartbuilder'
import { Moment } from '@chipinside/frontend'
import { Translate } from '@chipinside/translate'
import { PropsWithChildren } from 'react'

import { useFarmSlug } from '#/store/ducks/farm'
import { ChartBuilderColors } from '#/store/providers/Chartbuilder/colors'
import { ChartBuilderIcon } from '#/store/providers/Chartbuilder/Icon'

export function ChartBuilderProvider({ children }: PropsWithChildren) {
  const farmSlug = useFarmSlug()

  /* prettier-ignore */
  const formatters = {
    exportedFileName:                            item => `cowmed_${farmSlug}_${item}`.replaceAll('-', '_'),
    formatPlotLinesGroupTimestamp:               item => Moment(item.timestamp).startOf('h').valueOf(),
    plotLineCreatedText:                         () => Translate({ messageKey: 'created_by' }),
    plotLineRegisteredDateLabel:                 () => Translate({ messageKey: 'registered_at_date' }),
    plotLinesDate:                               timestamp => Moment(timestamp).format(Translate({ messageKey: 'date_format_long_timestamped' })),
    plotLinesSubmenuText:                        item => Translate({ messageKey: item }),
  }

  const components = {
    Icon: ChartBuilderIcon,
  }

  return (
    <ChartBuilderProviderPackage
      colors={ChartBuilderColors}
      formatters={formatters}
      components={components}
    >
      {children}
    </ChartBuilderProviderPackage>
  )
}
